import { useMemo } from 'react';
import { ProLayout } from '@ant-design/pro-components';
import { Avatar, Dropdown, App as AntdApp } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { MENU_ITEMS, type MenuItem } from '@/stores/menu';

function filterMenuByGroups(items: MenuItem[], hasAnyGroup: (g: string[]) => boolean): MenuItem[] {
  return items
    .filter((it) => !it.groups || it.groups.length === 0 || hasAnyGroup(it.groups))
    .map((it) => ({
      ...it,
      children: it.children ? filterMenuByGroups(it.children, hasAnyGroup) : undefined,
    }));
}

export default function LayoutWrapper() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAuthStore((s) => s.user);
  const hasAnyGroup = useAuthStore((s) => s.hasAnyGroup);
  const logout = useAuthStore((s) => s.logout);

  const filteredMenu = useMemo(
    () => filterMenuByGroups(MENU_ITEMS, hasAnyGroup),
    [hasAnyGroup, user],
  );

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <AntdApp>
      <ProLayout
        title="普通话考试管理后台"
        logo={false}
        layout="mix"
        location={{ pathname: location.pathname }}
        route={{
          path: '/',
          routes: filteredMenu.map((m) => ({
            path: m.path,
            name: m.name,
            icon: m.icon,
          })),
        }}
        menuItemRender={(item, dom) => (
          <a
            onClick={(e) => {
              e.preventDefault();
              if (item.path) navigate(item.path);
            }}
          >
            {dom}
          </a>
        )}
        avatarProps={{
          icon: <UserOutlined />,
          size: 'small',
          title: user?.email || user?.username || '未登录',
          render: (_, dom) => (
            <Dropdown
              menu={{
                items: [
                  {
                    key: 'logout',
                    icon: <LogoutOutlined />,
                    label: '退出登录',
                    onClick: handleLogout,
                  },
                ],
              }}
            >
              {dom}
            </Dropdown>
          ),
        }}
        actionsRender={() => [<Avatar key="a" size="small" icon={<UserOutlined />} />]}
      >
        <Outlet />
      </ProLayout>
    </AntdApp>
  );
}
